// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".184a01aba085aafd3d91e245482f461a8c032ad7.chunk.bundle.js";
};